module.exports = __webpack_public_path__ + "img/thumb_30.4db67783.jpg";